




































































import { Component, Prop, Vue } from "vue-property-decorator";

// Enums/Data
import { BrandTaxType, ProductOrderTypes } from "@/data/enums";

// Types
import { IBasketProduct } from "@/models/baskets";

@Component
export default class BasketItemDetails extends Vue {
  @Prop({ required: true })
  public basketProduct!: IBasketProduct;

  @Prop({ required: true })
  public brandTaxType!: BrandTaxType;

  // Data
  public zeroPrice = "";

  // Lifecycle methods
  public created() {
    if (this.basketProduct.price_option_override) this.getZeroPrice();
  }

  public get optionsGroupedByCategory() {
    return this.groupedByCategory(
      this.$_.filter(
        this.basketProduct.options,
        option => option.product.order_type !== ProductOrderTypes.SINGLE_OPTION
      )
    );
  }

  public get attributesGroupedByCategory() {
    return this.groupedByCategory(this.basketProduct.attributes);
  }

  // Methods
  public async getZeroPrice() {
    this.zeroPrice = await this.$store.dispatch("api/calculate", {
      prices: [0],
      currency_id: this.basketProduct.cost_currency_id,
      returnOnly: "total_formatted"
    });
  }
  public showPrice(formattedPrice: string) {
    return formattedPrice.replace(".00", "");
  }

  public groupedByCategory(items: IBasketProduct[]) {
    const clonedItems = this.$_.cloneDeep(
      this.$_.sortBy(items, [
        "product.category.order",
        "product.category.name_translated",
        "product.category.name",
        "product_name"
      ])
    ) as IBasketProduct[];

    const grouped = {};
    this.$_.forEach(clonedItems, item => {
      const key = `${item.product.category.name}-${item.product.category.name_translated}-${item.product.category.id}`;
      if (!this.$_.has(grouped, key)) {
        grouped[key] = item.product.category;
        grouped[key].products = [];
      }
      grouped[key].products.push(item);
    });

    return grouped;
  }

  public getBillingCycleString(billingCycleMonths) {
    if (!billingCycleMonths) {
      return "";
    }
    const name = this.$store.getters["constants/getBillingCycleName"](
      billingCycleMonths
    ).toLowerCase();

    return `(${name})`;
  }
}
